import { buildAppUrl } from '@/vue/utils/urlBuilder'

/**
 * Construye la URL absoluta de un endpoint de la API REST.
 *
 * Ajusta automáticamente el prefijo según se ejecute dentro o fuera de Docker.
 *
 * @param path - Ruta relativa del endpoint, con o sin barra inicial.
 * @returns URL absoluta del endpoint bajo `/api/v1`.
 */
export function apiUrl(path: string): string {
    const basePath = import.meta.env.VITE_ENTORNO_DOCKER === 'true' ? 'api/v1' : 'web/api/v1'

    return buildAppUrl(path, basePath)
}
